import uuid from 'uuid';

import {getBaseDomainUrl} from "../../api/jsonApi";
import {getCommonVisualizerType} from "../../config";
import {setMultiLoader} from "../../actions/actionFunctions";
import {toBase64} from "./aiFunctions";
import {
  setAILoading,
  setAIResults,
  setLookAiImageOpened,
  setLookAiRenderFinished,
  setLookAiWaitingBoxClicked
} from "./aiActions";
import {LOOK_OVERLAYS} from "../look/core/constants";

const newSwaggerHeaders = {
  'Accept': '*',
  'Content-Type': 'application/json'
}

export const getCurrentPrompts = async () => {
  const rawResponse = await fetch(`${getBaseDomainUrl()}:7122/api/Prompt`);
  const convertResponse = await rawResponse.json();
  console.log("convertResponse", convertResponse);
  if (!Array.isArray(convertResponse)) {
    return []
  }
  const visualizerType = getCommonVisualizerType();
  const filteredResponse = convertResponse.filter(prObject => prObject.tool === visualizerType);
  let firstActiveIndex = filteredResponse.findIndex(prObject => prObject.isDefault && (prObject.type === "First"));
  let secondActiveIndex = filteredResponse.findIndex(prObject => prObject.isDefault && (prObject.type === "Second"));
  if (firstActiveIndex === -1) {
    firstActiveIndex = filteredResponse.findIndex(prObject => prObject.type === "First"); // set at least something active
  }
  if (secondActiveIndex === -1) {
    secondActiveIndex = filteredResponse.findIndex(prObject => prObject.type === "Second"); // set at least something active
  }
  if (firstActiveIndex > -1) {
    filteredResponse[firstActiveIndex]["isActiveFirst"] = true;
  }
  if (secondActiveIndex > -1) {
    filteredResponse[secondActiveIndex]["isActiveSecond"] = true;
  }
  return filteredResponse
}

export const removePrompt = (pr) => {
  return fetch(`${getBaseDomainUrl()}:7122/api/Prompt/${pr.id}`, {
    method: 'DELETE',
  });
}

export const editPrompt = (pr) => {
  return fetch(`${getBaseDomainUrl()}:7122/api/Prompt`, {
    method: 'PATCH',
    headers: newSwaggerHeaders,
    body: JSON.stringify(pr)
  });
}

export const createPrompt = (postData) => {
  return fetch(`${getBaseDomainUrl()}:7122/api/Prompt`, {
    method: 'POST',
    headers: newSwaggerHeaders,
    body: JSON.stringify(postData)
  });
}

const setDefaultPrompts = async (activePromptFirst, activePromptSecond) => {
  if (activePromptFirst) {
    await fetch(`${getBaseDomainUrl()}:7122/api/Prompt/default/${activePromptFirst.id}`, {
      method: 'PATCH',
      headers: newSwaggerHeaders,
    })
  }
  if (activePromptSecond) {
    await fetch(`${getBaseDomainUrl()}:7122/api/Prompt/default/${activePromptSecond.id}`, {
      method: 'PATCH',
      headers: newSwaggerHeaders,
    })
  }
}

export const postGenerateAiImage = (popupContext) => {
  return async (dispatch, getState) => {
    const {groupObjects, userFile, promptsList} = popupContext;
    const storeState = getState();
    const {aiResults} = storeState.aiState;

    dispatch(setAILoading(true));
    dispatch(setMultiLoader({ activeStep: 0, visible: true, finished: false }));

    const featureDefinitionIDs = groupObjects
      .filter(groupObject => groupObject.enabled)
      .map(groupObject => {
        return groupObject.featureGroup.activeFeature.dbFeature.featureDefinitionID
      });

    const base64Code = await toBase64(userFile);

    const activePromptFirst = promptsList.find(promptObject => promptObject.isActiveFirst);
    const activePromptSecond = promptsList.find(promptObject => promptObject.isActiveSecond);
    if (!activePromptFirst) {
      return
    }

    await setDefaultPrompts(activePromptFirst, activePromptSecond);
    const jobId = document.kvConfig.jobId || storeState.serverState.jobId;

    const postData = {
      "fabricatorId": document.kvConfig.userId,
      "featureDefinitionIds": featureDefinitionIDs,
      "jobId": jobId,
      "userPhoto": {
        "b64File": base64Code,
        "fileName": userFile.name,
      },
      "tool": getCommonVisualizerType(),
      "firstPromptVersion": activePromptFirst.version,
      "secondPromptVersion": activePromptSecond ? activePromptSecond.version : 0
    }

    console.log("postData", postData);
    const rawResponse = await fetch(`${getBaseDomainUrl()}:7122/api/ImageProcessing/convert`, {
      method: 'POST',
      headers: newSwaggerHeaders,
      body: JSON.stringify(postData)
    });
    const convertResponse = await rawResponse.json();
    dispatch(setAILoading(false));

    dispatch(setAIResults([...aiResults, convertResponse]));
    console.log("convertResponse", convertResponse);
    return convertResponse ? convertResponse.resultImageUrl : "";
  }
}

export const postGenerateLookAiImage = (lookAiPopupContext) => {
  return async (dispatch, getState) => {

    const {userFile, groupObjects} = lookAiPopupContext;
    const {serverState} = getState();

    dispatch(setAILoading(true));

    const featureDefinitionIDs = groupObjects
      .filter(groupObject => groupObject.enabled)
      .map(groupObject => {
        return groupObject.featureGroup.activeFeature.dbFeature.featureDefinitionID
      });

    const base64Code = await toBase64(userFile);

    const postData = {
      "fabricatorId": document.kvConfig.userId,
      "featureDefinitionIds": featureDefinitionIDs,
      "jobId": document.kvConfig.jobId || serverState.jobId,
      "userPhoto": {
        "b64File": base64Code,
        "fileName": userFile.name,
      },
      "tool": getCommonVisualizerType(),
      // "firstPromptVersion": 0, // do not pass - we should use default ones
      // "secondPromptVersion": 0 // do not pass - we should use default ones
    }

    console.log("postData", postData);
    try {
      const rawResponse = await fetch(`${getBaseDomainUrl()}:7122/api/ImageProcessing/convert`, {
        method: 'POST',
        headers: newSwaggerHeaders,
        body: JSON.stringify(postData)
      });
      if (!rawResponse.ok) {
        const errorText = await rawResponse.text(); // fallback to raw text
        throw new Error(errorText || `Failed to generate image. Please try again later`);
      }
      const convertResponse = await rawResponse.json();

      const storeState = getState();
      const {aiResults, aiUserFileBlobUrl} = storeState.aiState;
      const {lookOverlayOpened} = storeState.lookState;

      const nextAiResults = aiResults.map(aiResult => {
        return Object.assign({}, aiResult, {isActive: false});
      })

      convertResponse.id = uuid.v4();
      convertResponse.isActive = true;
      convertResponse.sourceImageUrl = aiUserFileBlobUrl;

      dispatch(setAILoading(false));
      dispatch(setLookAiWaitingBoxClicked(true));
      if (nextAiResults.every(res => res.resultImageUrl)) {
        dispatch(setAIResults([...nextAiResults, convertResponse]));
      } else {
        const nextUnrenderedIndex = nextAiResults.findIndex(res => !res.resultImageUrl);
        if (nextUnrenderedIndex > -1) {
          nextAiResults[nextUnrenderedIndex] = convertResponse;
          dispatch(setAIResults([...nextAiResults]));
        }
      }

      if (lookOverlayOpened === LOOK_OVERLAYS.aiPanel) {
        dispatch(setLookAiImageOpened(true))
      } else {
        dispatch(setLookAiRenderFinished(true))
      }

      console.log("convertResponse", convertResponse);
      return convertResponse ? convertResponse.resultImageUrl : "";
    } catch (e) {
      const storeState = getState();
      const {aiResults} = storeState.aiState;
      const nextAiResults = aiResults.map(aiResult => {
        return Object.assign({}, aiResult, {isActive: false});
      })
      const convertResponse = {
        id: uuid.v4(),
        isActive: true,
        conversionError: e.message,
      }
      if (nextAiResults.every(res => res.resultImageUrl)) {
        dispatch(setAIResults([...nextAiResults, convertResponse]));
      } else {
        const nextUnrenderedIndex = nextAiResults.findIndex(res => !res.resultImageUrl);
        if (nextUnrenderedIndex > -1) {
          nextAiResults[nextUnrenderedIndex] = convertResponse;
          dispatch(setAIResults([...nextAiResults]));
        }
      }
      dispatch(setAILoading(false));
      dispatch(setLookAiWaitingBoxClicked(true));
    }
  }
}

// const sendImageToOpenAI = async (base64Image) => {
//   try {
//     // Convert base64 to blob
//     const byteString = atob(base64Image.split(',')[1]);
//     const mimeString = base64Image.split(',')[0].split(':')[1].split(';')[0];
//     const ab = new ArrayBuffer(byteString.length);
//     const ia = new Uint8Array(ab);
//     for (let i = 0; i < byteString.length; i++) {
//       ia[i] = byteString.charCodeAt(i);
//     }
//     const blob = new Blob([ab], { type: mimeString });
//
//     const file = new File([blob], 'image.png', { type: mimeString });
//
//     // Create form data
//     const formData = new FormData();
//     formData.append('image', file);
//     formData.append('n', '1'); // number of images to return
//     formData.append('size', '512x512'); // size can be 256x256, 512x512, 1024x1024
//
//     // Send to OpenAI API (proxy this through your backend in production!)
//     const response = await axios.post(
//       'https://api.openai.com/v1/images/variations',
//       formData,
//       {
//         headers: {
//           // 'Authorization': `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
//           'Content-Type': 'multipart/form-data',
//         },
//       }
//     );
//
//     return response.data.data[0].url; // Returns a URL to the new image
//   } catch (error) {
//     console.error('Error sending image to OpenAI:', error);
//     throw error;
//   }
// };

export const getCurrentPromptParts = async (promptObject) => {
  const rawResponse = await fetch(`${getBaseDomainUrl()}:7122/api/PromptParts/prompt/${promptObject.id}`);
  const convertResponse = await rawResponse.json();
  console.log("promptPartsResponse", convertResponse);
  if (!Array.isArray(convertResponse)) {
    return []
  }
  return convertResponse
}

export const updatePromptParts = (groupObject, promptObject, type) => {
  const isActiveBody = "partBody" + type;
  const savedPromptPartObject = "savedPromptPartObject" + type;

  if (groupObject[savedPromptPartObject]) { // update
    return fetch(`${getBaseDomainUrl()}:7122/api/PromptParts/${groupObject[savedPromptPartObject].id}`, {
      method: 'PUT',
      headers: newSwaggerHeaders,
      body: JSON.stringify(Object.assign({}, groupObject[savedPromptPartObject], {
        partBody: groupObject[isActiveBody],
      }))
    });
  } else { // create
    return fetch(`${getBaseDomainUrl()}:7122/api/PromptParts/list`, {
      method: 'POST',
      headers: newSwaggerHeaders,
      body: JSON.stringify([{
        "id": 0,
        "promptId": promptObject.id,
        "featureGroup": groupObject.featureGroup.dbName || groupObject.featureGroup.partName,
        "partBody": groupObject[isActiveBody] || ""
      }])
    });
  }
}
